import { render } from "./shopifyProblem.vue?vue&type=template&id=e13bbc86&scoped=true"
import script from "./shopifyProblem.vue?vue&type=script&lang=js"
export * from "./shopifyProblem.vue?vue&type=script&lang=js"

import "./shopifyProblem.vue?vue&type=style&index=0&id=e13bbc86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13bbc86"]])

export default __exports__